import "bootstrap/dist/css/bootstrap.min.css";
import "./Package.css";
import { Link } from "react-router-dom";

export default function Package() {
  return (
    <section className="pricing-section py-5">
      <div className="container">
        <div className="row g-4 justify-content-center">
        <h1 className="head-font text-center" >Our Packages</h1>
          {/* ===== PACKAGE 1 ===== */}
          <div className="col-lg-4 col-md-6">
            <div className="pricing-card text-center h-100">
              <h3 className="pkg-title">14 Days Postnatal Package Treatments Overview</h3><br/><br/>
              <span className="pkg-plan">Body Therapies</span>

              <ul className="pkg-list">
                <li>Abhyangam</li>
                <li>Podi Kizhi</li>
                <li>Ila Kizhi</li>
                <li>Naranga Kizhi</li>
                <li>Navara Kizhi</li>
                <li>Nadi Swedam</li>
                <li>Abdominal Binding</li>
              </ul>
               <span className="pkg-plan">Head, Face & Skin Care </span>

              <ul className="pkg-list">
                <li>Head Massage</li>
                <li>Face Massage </li>
                <li>Face Pack </li>
                <li>Body Pack </li>
                <li>Hairpack </li>
                <li>Facial </li>
                
                 </ul>
                   <span className="pkg-plan">Detox Therapies </span>

              <ul className="pkg-list">
                <li>Vethukuli </li>
                <li>Keshadhoomam </li>
                
                 </ul>
             <span className="pkg-plan">Sense Organ Care </span>

              <ul className="pkg-list">
                <li>Anjanam  </li>
                <li>Nasadhoomam </li>
                 <li>Thalam</li>
                 </ul>

              

             <Link to="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20book%20a%20consultation"
              target="_blank"
              rel="noopener noreferrer"
              className="btn book-btn"
              style={{textDecoration: "none" }}>Book Now</Link>
            </div>
          </div>

          {/* ===== PACKAGE 2 ===== */}
          <div className="col-lg-4 col-md-6">
            <div className="pricing-card text-center h-100">
              <h3 className="pkg-title">21 Days Postnatal Package Treatments Overview </h3><br/>
              <span className="pkg-plan">Body Therapies</span>

              <ul className="pkg-list">
                <li>Abhyangam </li>
                <li>Podi Kizhi  </li>
                <li>Ila Kizhi  </li>
                <li>Naranga Kizhi  </li>
                <li>Navara Kizhi</li>
                <li>Nadi Swedam </li>
                <li>Abdominal Binding </li>
               </ul>
               <span className="pkg-plan">Head, Face & Skin Care </span>

              <ul className="pkg-list">
                <li>Head Massage</li>
                <li>Face Massage </li>
                <li>Face Pack </li>
                <li>Body Pack </li>
                <li>Hairpack </li>
                <li>Facial </li>
                
                 </ul>
                  <span className="pkg-plan">Detox Therapies </span>

              <ul className="pkg-list">
                <li>Vethukuli </li>
                <li>Keshadhoomam </li>
                
                 </ul>
             <span className="pkg-plan">Sense Organ Care </span>

              <ul className="pkg-list">
                <li>Anjanam  </li>
                <li>Nasadhoomam </li>
                 <li>Shirodhara</li>
                  <li>Thalam</li>
                 </ul>

              

             <Link to="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20book%20a%20consultation"
              target="_blank"
              rel="noopener noreferrer"
              className="btn book-btn"
              style={{textDecoration: "none" }}>Book Now</Link>
            </div>
          </div>

          {/* ===== PACKAGE 3 ===== */}
          <div className="col-lg-4 col-md-6">
            <div className="pricing-card text-center h-100">
              <h3 className="pkg-title">28 Days Postnatal Package Treatments Overview</h3><br/>
                <span className="pkg-plan">Body Therapies</span>

              <ul className="pkg-list">
                <li>Abhyangam </li>
                <li>Podi Kizhi  </li>
                <li>Ila Kizhi  </li>
                <li>Naranga Kizhi  </li>
                <li>Navara Kizhi</li>
                <li>Nadi Swedam </li>
                <li>Kashayadhara</li>
                <li>Abdominal Binding </li>
               </ul>

               <span className="pkg-plan">Head, Face & Skin Care </span>

              <ul className="pkg-list">
                <li>Head Massage</li>
                <li>Face Massage </li>
                <li>Face Pack </li>
                <li>Body Pack </li>
                <li>Hairpack </li>
                <li>Facial </li>
                 <li>Pedicure</li>
                  <li>Manicure </li>
                   <li>Herbal Foot Pack  </li>
                    <li>Navara Theppu </li>
                
                 </ul>
                   <span className="pkg-plan">Detox Therapies </span>

              <ul className="pkg-list">
                <li>Vethukuli </li>
                <li>Keshadhoomam </li>
                
                 </ul>
             <span className="pkg-plan">Sense Organ Care </span>

              <ul className="pkg-list">
                <li>Anjanam  </li>
                <li>Nasadhoomam </li>
                 <li>Shirodhara</li>
                  <li>Thalam</li>
                 </ul>

              <Link to="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20book%20a%20consultation"
              target="_blank"
              rel="noopener noreferrer"
              className="btn book-btn"
              style={{textDecoration: "none" }}>Book Now</Link>
            </div>
          </div>

        </div>
      </div>
      <br /><br />

      <div style={{paddingLeft:'8%'}}>
        <h6><b>BECAUSE YOUR RECOVERY DESERVES EXTRA CARE</b></h6>
        <p>* Our complimentary postnatal care kit helps you heal traditionally at home.<br/>
           * Comprehensive postnatal care includes gentle baby bath and massage</p>
        


      </div>
    </section>
  );
}
